// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetSubscriptionStatisticsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSubscriptionStatisticsQuery = { subscriptionStatistics?: Array<{ type?: Types.NotificationType, totalCount: unknown, uniqueUsers: unknown }> };


export const GetSubscriptionStatisticsDocument = gql`
    query GetSubscriptionStatistics {
  subscriptionStatistics {
    type
    totalCount
    uniqueUsers
  }
}
    `;

/**
 * __useGetSubscriptionStatisticsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>(GetSubscriptionStatisticsDocument, options);
      }
export function useGetSubscriptionStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>(GetSubscriptionStatisticsDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionStatisticsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>;
export function useGetSubscriptionStatisticsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSubscriptionStatisticsQuery | undefined, GetSubscriptionStatisticsQueryVariables>;
export function useGetSubscriptionStatisticsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>(GetSubscriptionStatisticsDocument, options);
        }
export type GetSubscriptionStatisticsQueryHookResult = ReturnType<typeof useGetSubscriptionStatisticsQuery>;
export type GetSubscriptionStatisticsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionStatisticsLazyQuery>;
export type GetSubscriptionStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionStatisticsSuspenseQuery>;
export type GetSubscriptionStatisticsQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionStatisticsQuery, GetSubscriptionStatisticsQueryVariables>;